<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <img src="klemantina-logo.svg" alt="Klemantina Logo" class="logo">
      <h1>Klemantina</h1>
      <p class="subtitle">Client Portal</p>
    </div>

    <!-- Error Message -->
    <div class="error-message" *ngIf="error">
      {{ error }}
    </div>

    <!-- Login Form -->
    <form *ngIf="!showOtpForm" (ngSubmit)="onLogin()" class="login-form">
      <div class="form-group">
        <label for="email">Email</label>
        <input
          type="email"
          id="email"
          [(ngModel)]="email"
          name="email"
          placeholder="Enter your email"
          [disabled]="loading"
          autofocus
        />
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input
          type="password"
          id="password"
          [(ngModel)]="password"
          name="password"
          placeholder="Enter your password"
          [disabled]="loading"
        />
      </div>

      <button type="submit" class="btn-primary" [disabled]="loading">
        <span *ngIf="!loading">Sign In</span>
        <span *ngIf="loading">Signing in...</span>
      </button>
    </form>

    <!-- OTP Form -->
    <form *ngIf="showOtpForm" (ngSubmit)="onVerifyOtp()" class="login-form">
      <p class="otp-info">
        We've sent a verification code to<br>
        <strong>{{ email }}</strong>
      </p>

      <div class="form-group">
        <label for="otp">Verification Code</label>
        <input
          type="text"
          id="otp"
          [(ngModel)]="otpCode"
          name="otp"
          placeholder="Enter 6-digit code"
          maxlength="6"
          [disabled]="loading"
          autofocus
        />
      </div>

      <button type="submit" class="btn-primary" [disabled]="loading">
        <span *ngIf="!loading">Verify Code</span>
        <span *ngIf="loading">Verifying...</span>
      </button>

      <div class="otp-actions">
        <button type="button" class="btn-link" (click)="onResendOtp()" [disabled]="loading">
          Resend Code
        </button>
        <button type="button" class="btn-link" (click)="onBackToLogin()">
          Back to Login
        </button>
      </div>
    </form>

    <div class="admin-link">
      <a routerLink="/admin">Admin Login →</a>
    </div>
  </div>
</div>

